import { connect } from 'react-redux'
import CollaborativeIndexation from './CollaborativeIndexation.jsx'
import {
    activateCollaborativeIndexerStatus,
    confirmCloseCollaborativeIndexationCreation,
} from '../../../../redux/collaborativeIndexations/actions'
import { getCollaborativeIndexationLicense } from '../../../../redux/app/selectors'

const mapDispatchToProps = (dispatch) => ({
    accept: () => dispatch(activateCollaborativeIndexerStatus()),
    refuse: () => dispatch(confirmCloseCollaborativeIndexationCreation()),
})

const mapStateToProps = state => ({
    license: getCollaborativeIndexationLicense(state),
})

export const CollaborativeIndexationContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(CollaborativeIndexation)
